module.exports = __webpack_public_path__ + "media/img/apple-icon-114x114-49c762f7c66ffbc0f0f5ec414247fdaf.png";